import React, { Component,useState } from "react";
import _ from 'underscore';
import { withRouter, Redirect } from 'react-router-dom'
import PageTitle from "../Theme/PageTitle";
import { Col, Row, Button, Modal, Tooltip } from "antd";
import Widget from '../Theme/Widget';
import DashboardLayout from "../Theme/DashboardLayout";
import moment from 'moment'
import CalendarMonth from './CalendarMonth';
import Spinner from '../Theme/Spinner';
import DayTypeRequestsCalendarUpdate from './DayTypeRequestsCalendarUpdate';
import ResourceDayTypeCalendarUpdate from './ResourceDayTypesCalendarUpdate';
import CalendarLegend from './CalendarLegend';
import trueBlankDayTypeRequest from './utils/day-type-requests/trueBlankDayTypeRequest';
import blankResourceDayType from './utils/day-type-requests/blankResourceDayType';
import dayTypeRequestsArray from './utils/day-type-requests/dayTypes';
import dayTypesArray from '../Schedule/utils/live-schedules/drop-down-tables/dayTypes';
import statusArray from './utils/day-type-requests/status';
import generateCalendarEvents from '../../Components/DayType/utils/generate-events';
import AuthLogic from '../../AuthLogic/';
import * as dayTypeActions from '../../redux/actions/dayTypeActions';
import * as resourceActions from '../../redux/actions/resourceActions';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';



const lodash = require('lodash');


class DayTypeCalendarView extends Component {
  constructor(props) {
    
    super(props);
    this.state = {
      widescreen: false,
      resource: this.props.selectedDayTypeResource,
      events: '',
      eventsWithSelectedDates: [],
      summaries: '',
      backRedirect: '',
      startDate: '',
      calendarMonths: '',
      contextMenuKey: false,
      dayTypeDetailModal: false,
      resourceDayTypeModal: false,
      selectedDates: [],
      selectedResourceDayType: '',
      selectedDayTypeRequest: '',
      loaded: false,
      loggedResource: this.props.user.login.resourceId == null ?  this.props.selectedDayTypeResource.id : this.props.user.login.resourceId
    }
     
  }

  

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();

    this.checkResource();

    let startDate;
    if (this.props.location.state) {  // redirected from DayTypesPage with props

      startDate = this.props.location.state.startDate;
      if (moment.isMoment(startDate)) {
        startDate = startDate.format('MM/DD/YYYY');
      }
      await this.props.actions.updateDayTypeCalendarScheduleParameters({ startDate });

    } else { // on refresh, pull state from local storage

      startDate = lodash.cloneDeep(this.props.startDate);
      if (moment.isMoment(startDate)) {
        startDate = startDate.format('MM/DD/YYYY')
      }
    }

    this.setState({
      startDate
    }, () => { this.readyApiCall() });

    this.customBrowserBackNavigation();
  }

  checkResource = () => {
    let resource;
    if (!this.state.resource.id && !this.state.resource.name) {
      resource = {
        id: this.props.user.login.resourceId,
        name: this.props.user.userDemographics.name
      }
      this.setState({
        resource
      });
    }
  }

  readyApiCall = () => {
    this.setState({
      loaded: false
    }, () => {
      this.getDataFromApi();
    })
  }

  getDataFromApi = async () => {

    let hasError = false;
    await this.props.actions
      .fetchDayTypeCalendar(
        this.state.resource.id,
        parseInt(moment(this.state.startDate).format().slice(0, 4)),
        parseInt(moment(this.state.startDate).format().slice(5, 7)),
        this.props.user.securityLevels.showOnCalendar,
        this.props.user.login.id,
      )
      .catch(error => {
        hasError= true;
        alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
      });
      
      if (hasError) {
        this.setvoidState();
        return;
      }

      const isApprover = AuthLogic.isApprover(this.props.user);

      await this.props.actions.fetchDayTypesAll(isApprover, this.state.resource.id, moment().format('YYYY-MM-DD'),this.props.user.login.id)
        .catch(error => {
          if (!_.isEmpty(error)) {
            hasError = true;
            alert("Your STORM Resource account is not set up correctly; please contact the STORM Team.");
          }
        });

        if (hasError) {
          this.setvoidState();
          return;
        }
      
      await this.props.actions.fetchDayTypesByDayRule({resourceId: this.state.resource.id, userId: this.props.user.login.id})
        .catch(error => {
          if (!_.isEmpty(error)) {
            alert("Your STORM Resource account is not set up correctly; please contact the STORM Team");
          }
        });
        
        if (hasError) {
          this.setvoidState();
          return;
        }
      
      const showUnapproved = this.props.user.securityLevels.dtTabUnapprovedDOR == 1;
      const calendarEvents = await generateCalendarEvents(this.props.dayTypeCalendar, 
        this.props.user.login.id, 
        this.props.selectedDayTypeResource.id, 
        this.props.dayTypesByDayRule, 
        this.state.loggedResource == this.state.resource.id, 
        showUnapproved,
        this.props.dayTypesAll)
      .catch(error => {
        alert("Generate Calendar Events failed\n" + JSON.stringify(error));
      });


      await this.props.actions.fetchDayTypesAllWithoutForceTour(
      {
        isApprover: !!isApprover,
        resourceId: this.state.resource.id,
        date: moment().format('YYYY-MM-DD'),
        withForceTour: false,
        userId: this.props.user.login.id
      }
      )
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getDayTypesAllWithForceTour failed\n" + JSON.stringify(error));
        }
      });

      this.setState({
      events: calendarEvents,
      eventsWithSelectedDates: calendarEvents,
      summaries: this.props.dayTypeCalendar.dayTypeSummariesByYear.dayTypeSummaries,
      selectedDates: [],
      loaded: true
    });
  }

  setvoidState = () => {
    this.setState({
      events: [],
      eventsWithSelectedDates: [],
      summaries: [],
      selectedDates: [],
      loaded: true
    });
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.history.location;
      if (pathname === '/day-types-calendar-view') {
        this.setState({
          backRedirect: '/day-types'
        });
      }
    }
  }

  handleAddDate = (event) => {
    event.end = moment(event.end).add(-1,'days').toDate()
    this.setState(previousState=>({selectedDates:[...previousState.selectedDates,event]}));
  }
  handleRemoveDate = (event)=> {
    this.setState(previousState => {
      
      const filteredEvents = previousState.selectedDates.filter(
        (item)=> {
          return !(item.start.toISOString()  == event.start.toISOString() && moment(item.end).add(1,"days").toDate().toISOString() == event.end.toISOString()  ) }
        );
      
      return { selectedDates: filteredEvents }
    })
  }

  handleDayTypeRequestEditForSelectedDate = async () => {
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let dayTypeRequestId;
    eventArrayCopy.forEach((event, index) => { //see if date has an event
      if (event.start && event.start === selectedDatesCopyArray[0] && event.dayTypeRequestId) {
        dayTypeRequestId = event.dayTypeRequestId;
      }
    });

    if (dayTypeRequestId) {
      await this.props.actions.fetchDayTypeRequestById({ id: dayTypeRequestId });
      let dayTypeRequestInfo = { ...this.props.dayTypeRequestInfo[0] };

      let foundDayType = dayTypeRequestsArray.find(dayType => dayType.id === dayTypeRequestInfo.dayTypeId);
      let foundStatus = statusArray.find(status => status.value === dayTypeRequestInfo.status);

      dayTypeRequestInfo.status = foundStatus.name;
      dayTypeRequestInfo.dayTypeCode = foundDayType.name;
      dayTypeRequestInfo.myComment = dayTypeRequestInfo.remark;
      dayTypeRequestInfo.statusComment = dayTypeRequestInfo.statusRemark;

      this.setState({
        selectedDayTypeRequest: await dayTypeRequestInfo
      }, () => {
        this.showModal();
      })
    }
  }

  handleResourceDayTypeEditForSelectedDate = async () => {
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let resourceDayTypeId;
    eventArrayCopy.forEach((event, index) => { //see if date has an event
      if (event.start && event.start === selectedDatesCopyArray[0] && event.resourceDayTypeId) {
        resourceDayTypeId = event.resourceDayTypeId;
      }
    });

    if (resourceDayTypeId) {
      await this.props.actions.fetchResourceDayTypeById({ resourceDayTypeId: resourceDayTypeId });

      let resourceDayTypeinfo = { ...this.props.resourceDayTypeinfo.data[0] };
      let foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeId === resourceDayTypeinfo.dayTypeId);

      if (foundDayType) {
        resourceDayTypeinfo.dayType = foundDayType.dayTypeName;
        resourceDayTypeinfo.allDayTypes = true;
      } else {
        foundDayType = dayTypesArray.find(dayType => dayType.id === resourceDayTypeinfo.dayTypeId);
        resourceDayTypeinfo.dayType = foundDayType.name;
        resourceDayTypeinfo.allDayTypes = false;
      }

      this.setState({
        selectedResourceDayType: await resourceDayTypeinfo
      }, () => {
        this.showResourceDayTypeModal();
      })
    }
  }

  handleDateSelection = (operation, date) => {
    /*TODO: remove*/
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let hasEvent = false;

    switch (operation) {
      case 'add':
        eventArrayCopy.forEach((event, index) => { //see if date has an event
          if (event.start && event.start === date && event.rendering === 'background') {
            hasEvent = true;
            let newEvent = { ...event };
            newEvent.color = 'red';
            eventArrayCopy[index] = newEvent;
          }
        });

        if (!hasEvent) {
          let newEvent = {
            color: 'red',
            isCalendarEvent: true, //flag for 'remove'
            rendering: 'background',
            start: date,
          }
          eventArrayCopy.push(newEvent);
        }
        break;
      case 'remove':
        eventArrayCopy.forEach((event, index) => { //see if date has an event
          if (event.start && event.start === date && event.rendering === 'background') {
            hasEvent = true;
            let newEvent = { ...event };

            if (!newEvent.isCalendarEvent) { //if it is from the API reset it
              newEvent.color = this.state.events[index].color || 'white';
              eventArrayCopy[index] = newEvent;
            } else { //if we made the event it needs to be delete
              if (index > -1) {
                eventArrayCopy.splice(index, 1);
              }
            }
          }
        });
        break;
      case 'clear':
        selectedDatesCopyArray = [];
        eventArrayCopy = this.state.events.slice();
        break;
      default:
        break;
    }

    this.setState({
      eventsWithSelectedDates: eventArrayCopy,
      selectedDates: selectedDatesCopyArray
    });
  }

  clearSelected = () => {
    this.setState({
      selectedDates: []
    });
  }

  checkForDayTypeRequestEdit = () => {
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let foundEvent = false;
    if (selectedDatesCopyArray.length === 1) { //check if there is only one date selected
      eventArrayCopy.forEach((event, index) => { //see if date has an event
        if (event.start && event.start === selectedDatesCopyArray[0] && event.dayTypeRequestId) { //if so allow the edit button to be pressed
          foundEvent = true;
        }
      });
      if (foundEvent) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  checkForResourceDayTypeEdit = () => {
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let foundEvent = false;
    if (selectedDatesCopyArray.length === 1) { //check if there is only one date selected
      eventArrayCopy.forEach((event, index) => { //see if date has an event
        if (event.start && event.start === selectedDatesCopyArray[0] && event.resourceDayTypeId) { //if so allow the edit button to be pressed
          foundEvent = true;
        }
      });
      if (foundEvent) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  resize = () => {
    if (window.innerWidth >= 990) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  addMonths = (startDate, numMonths) => {
    let year = parseInt(moment(startDate).format().slice(0, 4));
    const startMonth = parseInt(moment(startDate).format().slice(5, 7));
    let newMonth;
    if (startMonth + numMonths > 12) { // handle year increment
      year += 1;
      newMonth = (startMonth + numMonths) - 12;
    } else {
      newMonth = startMonth + numMonths;
    }
    return `${year}-${newMonth}`;
  }


  showCreateModal = () => {
    let request = {...trueBlankDayTypeRequest};

    if(this.state.selectedDates.length ==1) {
      request = {
        ...trueBlankDayTypeRequest,
        fromDate: this.state.selectedDates[0].start,
        toDate:  this.state.selectedDates[0].end
      };
    } 
    request.selectedDates = [...this.state.selectedDates];
    request.isMultiDates = request.selectedDates.length > 1
    
    //if one day is selected when creating set that as date in the form
    this.setState({
      contextMenuKey: true,
      selectedDayTypeRequest: request
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  showModal = () => {
    this.setState({
      contextMenuKey: false
    }, () => {
      this.setState({
        dayTypeDetailModal: true
      });
    })
  }

  handleModalCancel = (e) => {
    this.setState({
      dayTypeDetailModal: false,
    });
  }

  showResourceDayTypeCreateModal = async () => {
    let selectedDatesCopyArray = this.state.selectedDates.slice();
    let eventArrayCopy = this.state.eventsWithSelectedDates.slice();

    let resourceDayTypeId;
    eventArrayCopy.forEach((event, index) => { //see if date has an event
      if (event.start && event.start === selectedDatesCopyArray[0] && event.resourceDayTypeId) {
        resourceDayTypeId = event.resourceDayTypeId;
      }
    });

    let resourceDayTypeinfo;
    if (resourceDayTypeId) {
      await this.props.actions.fetchResourceDayTypeById({ resourceDayTypeId: resourceDayTypeId });

      resourceDayTypeinfo = { ...this.props.resourceDayTypeinfo.data[0] };
      let foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeId === resourceDayTypeinfo.dayTypeId);

      if (foundDayType) {
        resourceDayTypeinfo.dayType = foundDayType.dayTypeName;
        resourceDayTypeinfo.allDayTypes = true;
      } else {
        foundDayType = dayTypesArray.find(dayType => dayType.id === resourceDayTypeinfo.dayTypeId);
        resourceDayTypeinfo.dayType = foundDayType.name;
        resourceDayTypeinfo.allDayTypes = false;
      }
    }

    //if one day is selected when creating set that as date in the form
    this.setState({
      contextMenuKey: true,
      selectedResourceDayType: resourceDayTypeinfo
        ?
        resourceDayTypeinfo
        :
        { ...blankResourceDayType }
    }, () => {
      this.setState({
        resourceDayTypeModal: true
      });
    })
  }

  showResourceDayTypeModal = () => {
    this.setState({
      contextMenuKey: false
    }, () => {
      this.setState({
        resourceDayTypeModal: true
      });
    })
  }

  handleResourceDayTypeModalCancel = (e) => {
    this.setState({
      resourceDayTypeModal: false,
    });
  }

  render() {
    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/day-types');
      return <Redirect to={this.state.backRedirect} />
    }

    if (this.state.startDate && this.state.events && this.state.summaries && this.state.loaded) {
      return (
        <DashboardLayout>
          <PageTitle title={'Days Off: Calendar View'}
            subTitle={this.state.resource.name}
          />

          <CalendarLegend />
          {(AuthLogic.addDayTypeRequest(this.props.user) && this.props.user.mobileSecurity.canEdit==3 ) && (
            <Button style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.showCreateModal}>
              Create Day Type Requests
            </Button>
          )}

          {/* {AuthLogic.changeDayType(this.props.user) && (
            <Button style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.showResourceDayTypeCreateModal}>
              Create Resource Day Type
            </Button>
          )} */}


          {/*AuthLogic.editDayTypeRequest(this.props.user) && (
            <Button disabled={this.checkForDayTypeRequestEdit()} style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.handleDayTypeRequestEditForSelectedDate}>
              Edit/Delete Day Type Request
            </Button>
          )*/}

          {/* {AuthLogic.changeDayType(this.props.user) && (
            <Button disabled={this.checkForResourceDayTypeEdit()} style={{ marginTop: 20 }} type="primary" size={'large'} htmlType="submit" onClick={this.handleResourceDayTypeEditForSelectedDate}>
              Edit/Delete Resource Day Type
            </Button>
          )} */}

          {/* <Button disabled={this.state.selectedDates && this.state.selectedDates.length > 0 ? false : true} style={{ marginTop: 20 }} type="danger" size={'large'} htmlType="submit" onClick={() => { this.handleDateSelection('clear', null) }}>
            Clear Calendar Selection
          </Button> */}
           {(AuthLogic.addDayTypeRequest(this.props.user) && this.props.user.mobileSecurity.canEdit==3 ) && (
           <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
             <label style ={{color:"#40a9ff", marginTop:"2em"}}>To see more info on a date, tap on it.  To select dates in the calendar, press the date for 2 seconds until it turns green, and then click on the blue 'Create Day Type Requests' button.</label>
           </Row>)}

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events={this.state.events}
              month={moment(this.state.startDate).startOf('month').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 1), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 2), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 3), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 4), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 5), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 6), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 7), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events= {this.state.events}
              month={moment(this.addMonths(this.state.startDate, 8), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 9), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>

          <Row lg={8} md={24} style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 10), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
            <CalendarMonth
              events={this.state.events}
              month={moment(this.addMonths(this.state.startDate, 11), 'YYYY-M').format('YYYY-MM')}
              handleAddDate={this.handleAddDate}
              handleRemoveDate={this.handleRemoveDate}
              selectedDates={this.state.selectedDates}
              isDarkMode={this.props.theme}
              selectable ={this.props.user.mobileSecurity.canEdit==3}
            />
          </Row>
          {
            this.state.summaries.scheduledDays
            && this.state.summaries.timekeeperDays
            && this.state.summaries.UnapprovedRequestedOff
            &&

            (
              <div style={{ display: this.state.widescreen ? "flex" : null, justifyContent: "space-evenly" }}>
                <Col
                  lg={6} md={24}
                >
                  <Widget
                    title={'Scheduled days in this calendar view'}
                  >
                    <hr style={{ marginTop: -15 }} />
                    <ul>
                      {this.state.summaries.scheduledDays.map((dayType, i) => {
                        return (
                          <li key={i}>{`${dayType.dayTypeCode} (${dayType.dayTypeName}) - ${dayType.total}`}</li>
                        )
                      })}
                    </ul>
                  </Widget>
                </Col>

                <Col
                  lg={6} md={24}
                >
                  <Widget
                    title={"Days sent to Timekeeper"}
                  >
                    <hr style={{ marginTop: -15 }} />
                    <ul>
                      {this.state.summaries.timekeeperDays.map((dayType, i) => {
                        return (
                          <li key={i}>{`${dayType.dayTypeCode} (${dayType.dayTypeName}) - ${dayType.total}`}</li>
                        )
                      })}
                    </ul>
                  </Widget>
                </Col>

                <Col
                  lg={6} md={24}
                >
                  <Widget
                    title={"Unapproved Requested Days-Off"}
                  >
                    <hr style={{ marginTop: -15 }} />
                    <ul>
                      {this.state.summaries.UnapprovedRequestedOff.map((dayType, i) => {
                        return (
                          <li key={i}>{`${dayType.dayTypeCode} (${dayType.dayTypeName}) - ${dayType.total}`}</li>
                        )
                      })}
                    </ul>
                  </Widget>
                </Col>
              </div>
            )
          }

          <Modal
            zIndex={2000}
            title={'Day Type Request'}
            visible={this.state.dayTypeDetailModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[]}
          >
            <DayTypeRequestsCalendarUpdate
              readyApiCall={this.readyApiCall}
              selectedDayTypeRequest={this.state.selectedDayTypeRequest}
              selectedDates={this.state.selectedDates}
              handleModalCancel={this.handleModalCancel}
              contextMenuKey={this.state.contextMenuKey}
            />
          </Modal>

          <Modal
            zIndex={2000}
            title={'Resource Day Type'}
            visible={this.state.resourceDayTypeModal}
            onCancel={this.handleResourceDayTypeModalCancel} // the x in top right corner
            footer={[]}
          >
            <ResourceDayTypeCalendarUpdate
              readyApiCall={this.readyApiCall}
              selectedResourceDayType={this.state.selectedResourceDayType}
              selectedDates={this.state.selectedDates}
              handleModalCancel={this.handleResourceDayTypeModalCancel}
              contextMenuKey={this.state.contextMenuKey}
            />
          </Modal>
        </DashboardLayout>
      )
    } else
      return <Spinner />
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    selectedDayTypeResource: state.selectedDayTypeResource,
    dayTypeCalendar: state.dayTypeCalendar,
    dayTypeSecurity: state.dayTypeSecurity,
    dayTypeRequestInfo: state.dayTypeRequestInfo,
    resourceDayTypeinfo: state.resourceDayType,
    dayTypesAll: state.dayTypesAll.dayTypes,
    hamburgerMenu: state.navigation.hamburgerMenu,
    startDate: state.dayTypeCalendarScheduleParameters.startDate,
    theme: state.navigation.theme,
    dayTypesByDayRule: state.dayTypesByDayRule.dayTypes
  }
}

DayTypeCalendarView.propTypes = {
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDayTypeCalendar: bindActionCreators(
        dayTypeActions.fetchDayTypeCalendar,
        dispatch
      ),
      fetchDayTypeRequestById: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestById,
        dispatch
      ),
      fetchResourceDayTypeById: bindActionCreators(
        dayTypeActions.fetchResourceDayTypeById,
        dispatch
      ),
      updateSelectedDayTypeResource: bindActionCreators(
        resourceActions.updateSelectedDayTypeResource,
        dispatch
      ),
      fetchDayTypesAll: bindActionCreators(
        dayTypeActions.fetchDayTypesAll,
        dispatch
      ),
      fetchDayTypesAllWithoutForceTour: bindActionCreators(
        dayTypeActions.fetchDayTypesAllWithoutForceTour,
        dispatch
      ),
      fetchDayTypeSecurity: bindActionCreators(
        dayTypeActions.fetchDayTypeSecurity,
        dispatch
      ),
      updateDayTypeCalendarScheduleParameters: bindActionCreators(
        dayTypeActions.updateDayTypeCalendarScheduleParameters,
        dispatch
      ),
      fetchIfHasHolidaySchedule: bindActionCreators(
        dayTypeActions.fetchIfHasHolidaySchedule,
        dispatch
      ),
      fetchDayTypesByDayRule: bindActionCreators(
        dayTypeActions.fetchDayTypesByDayRule,
        dispatch
      )
    }
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DayTypeCalendarView));



// WEBPACK FOOTER //
// ./src/Components/DayType/DayTypeCalendarView.js